import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import IconButton from '@material-ui/core/IconButton';
import GetAppIcon from '@material-ui/icons/GetApp';
import CircularProgress from '@material-ui/core/CircularProgress';
import Tooltip from '@material-ui/core/Tooltip';
import Fade from '@material-ui/core/Fade';
import PBI_SRC from '../../common/constants/PowerbiSourceUrl';
import CSVFilesImportPopUp from './CSVFilesImportPopUp';
import ForecastSimulationSuccessAlert from './ForecastSimulationSuccessAlert';
import SuccessUpdateAlert from '../TicketDetails/SuccessUpdateAlert';
import TechnicalErrorAlert from '../TechnicalErrorAlert/TechnicalErrorAlert';
import ApiService from '../../services/ApiService';

import useStyles from './styles';
import { setDrawerOpened } from '../HomePage/ContentTabs/ContentTabsSlice';

export default function WagonSimulationPage() {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [openCSVFilesImportPopUp, setOpenCSVFilesImportPopUp] =
    React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [displaySuccessPopup, setDisplaySuccessPopup] = React.useState(false);
  const [triggerSanboxMailSuccessMessage, setTriggerSanboxMailSuccessMessage] =
    React.useState(null);
  const [
    openForecastSimulationSuccessAlert,
    setOpenForecastSimulationSuccessAlert,
  ] = React.useState(false);
  const [openTechnicalErrorAlert, setOpenTechnicalErrorAlert] =
    React.useState(false);
  const [triggerSandboxMailErrorMessage, setTriggerSandboxMailErrorMessage] =
    React.useState(null);
  const handleClickAway = () => {
    dispatch(setDrawerOpened(false));
  };
  const triggerSandboxMail = () => {
    setLoading(true);
    ApiService.triggerSandboxMail()
      .then(() => {
        setLoading(false);
        setDisplaySuccessPopup(true);
        setTriggerSanboxMailSuccessMessage(t('Sandbox mail sent message'));
      })
      .catch(() => {
        setLoading(false);
        setOpenTechnicalErrorAlert(true);
        setTriggerSandboxMailErrorMessage(t('Technical error occurred'));
      });
  };
  function closeSuccessPopUp() {
    setDisplaySuccessPopup(false);
    setTriggerSanboxMailSuccessMessage(null);
  }
  function handleCloseTechnicalErrorAlert() {
    setOpenTechnicalErrorAlert(false);
    setTriggerSandboxMailErrorMessage(null);
  }
  return (
    <div>
      <div className={classes.root}>
        <Grid container spacing={0}>
          <Typography className={classes.title}>
            {t('Wagon availability forecast simulation')}
          </Typography>
          <Paper elevation={0} className={classes.contentPaper}>
            <div className={classes.description}>
              {t('forecast simulation description')}
            </div>
            <div
              className={classes.iframe}
              data-testid="wagon-availability-sandbox-chart"
            >
              {loading && (
                <Paper
                  elevation={0}
                  position="absolute"
                  zindex="2"
                  data-testid="loader"
                >
                  <CircularProgress className={classes.loader} />
                </Paper>
              )}
              <iframe
                style={openCSVFilesImportPopUp ? { pointerEvents: 'none' } : {}}
                onLoad={handleClickAway}
                title="Wagon availability forecast simulation"
                width="100%"
                height="550px"
                src={PBI_SRC.sandboxSimulationChartSrc}
                frameBorder="0"
                allowFullScreen
              />
            </div>
          </Paper>
        </Grid>
      </div>
      <div>
        <Tooltip
          TransitionComponent={Fade}
          title={t('validation files description')}
          arrow
        >
          <IconButton
            aria-label="upload"
            data-testid="upload"
            className={classes.uploadButton}
            onClick={() => setOpenCSVFilesImportPopUp(true)}
          >
            <AutorenewIcon />
          </IconButton>
        </Tooltip>
        <Tooltip TransitionComponent={Fade} title={t('save excel file')} arrow>
          <IconButton
            aria-label="download"
            data-testid="download"
            className={classes.downloadButton}
            onClick={() => triggerSandboxMail()}
          >
            <GetAppIcon />
          </IconButton>
        </Tooltip>
      </div>
      <CSVFilesImportPopUp
        openCSVFilesImportPopUp={openCSVFilesImportPopUp}
        closeCSVFilesImportPopUp={() => setOpenCSVFilesImportPopUp(false)}
        openForecastSimulationAlert={() =>
          setOpenForecastSimulationSuccessAlert(true)
        }
      />
      <ForecastSimulationSuccessAlert
        forecastSimulationSuccessAlert={openForecastSimulationSuccessAlert}
        handleCloseForcastSimulationSuccessAlert={() =>
          setOpenForecastSimulationSuccessAlert(false)
        }
      />
      <SuccessUpdateAlert
        successPopup={displaySuccessPopup}
        successMessage={triggerSanboxMailSuccessMessage}
        handleCloseSuccessUpdateAlert={closeSuccessPopUp}
      />
      <TechnicalErrorAlert
        openTechnicalErrorAlert={openTechnicalErrorAlert}
        technicalErrorMessage={triggerSandboxMailErrorMessage}
        handleCloseTechnicalErrorAlert={handleCloseTechnicalErrorAlert}
      />
    </div>
  );
}
